export function AccAuditCheckListFactory() {
    return function AccAuditCheckList() {

        this.id = null;
        this.standard = null;
        this.checklistItems = [];
        this.progress = 0;
    };
}
